export default "__VITE_ASSET__86NzkqxQ__"